export type TranslationGetter<DictType> = (dict: DictType) => string

export class Translatable<DictType> {
  public args: unknown[]

  constructor(public dictId: string, public getter: TranslationGetter<DictType>, ...args: unknown[]) {
    this.args = args
  }
}

export function translatable<DictType>(
  dictId: string,
  getter: TranslationGetter<DictType>,
  ...args: unknown[]
): Translatable<DictType> {
  return new Translatable(dictId, getter, ...args)
}
